import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

const ArrowBack: FC<SvgIconProps> = (props) => (
  <SvgIcon
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.8478 6.25281H2.71861L9.37978 0.275281C9.4863 0.178933 9.42163 0 9.28088 0H7.59751C7.52333 0 7.45295 0.027528 7.39779 0.0766853L0.209732 6.52416C0.143898 6.58315 0.0910992 6.65608 0.0549134 6.73801C0.0187275 6.81994 0 6.90895 0 6.99902C0 7.08908 0.0187275 7.17809 0.0549134 7.26002C0.0910992 7.34195 0.143898 7.41488 0.209732 7.47388L7.43964 13.9607C7.46817 13.9862 7.50241 14 7.53855 14H9.27897C9.41973 14 9.4844 13.8191 9.37788 13.7247L2.71861 7.74719H13.8478C13.9315 7.74719 14 7.6764 14 7.58989V6.41011C14 6.3236 13.9315 6.25281 13.8478 6.25281Z"
      fill="#BDBDBD"
    />
  </SvgIcon>
);

export default ArrowBack;
